<template>
    <div>
        <div class="row text-center">
            <div class="col-lg-4 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">نام مشتری :</span>
                    </div>
                    <vs-select :data="providers" :mode="'create'"
                               :header="{multiple: false, label: 'outSourceName'}"
                               @onChange="onChange"></vs-select>
                </div>
            </div>
            <div class="col-lg-8 col-12 mt-2">
                <div class=" d-inline-block mx-3">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend" @click="toggleStartDatePicker">
                            <div class="input-group-text"><span>از تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                     ref="datePickerStart" style="flex: 1">
                            <slot>
                                <input v-model="startDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleStartDatePicker">
                                <button class="close reset-date" @click="resetStartDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <div class="d-inline-block mx-3">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend" @click="toggleEndDatePicker">
                            <div class="input-group-text"><span>تا تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" :disable="startDatePersian" format="jYYYY-jMM-jDD"
                                     @input="onEndDatePicked"
                                     ref="datePickerEnd" style="flex: 1; transform">
                            <slot>
                                <input v-model="endDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleEndDatePicker">
                                <button class="close reset-date" @click="resetEndDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <!--<div class="d-inline-block mx-3">-->
                <!--<button class="btn btn-primary" @click="getReport">ثبت</button>-->
                <!--</div>-->
            </div>
        </div>
        <hr/>
        <div class="row" v-if="listView">
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in vouchers">
                <div class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-3">
                            <strong>مشتری: </strong>
                            <span>{{item.receiveOutSourceName}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>شماره سند: </strong>
                            <span>{{item.voucherNumber}}</span>
                        </div>
                        <!--<div class="col-md-3">-->
                        <!--<strong>تعداد محصولات: </strong>-->
                        <!--<span>{{item.productCount}}</span>-->
                        <!--</div>-->
                        <div class="col-md-3">
                            <strong>تاریخ سند: </strong>
                            <span>{{item.voucherDate}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>مبلغ: </strong>
                            <span class="text-success">{{item.price.toLocaleString()}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-3 col-sm-6 product-container" v-for="(item, index) in vouchers">
                <div :class="{active: item.unitVal > 0}" class="card temp-voucher mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="card-body">
                        <div class="row p-2">
                            <div class="col-12 text-center">
                                <div class="text-success">
                                    <h5 class="d-inline">مبلغ: </h5>
                                    <h5 class="d-inline">{{item.price.toLocaleString()}}</h5>
                                </div>
                            </div>
                            <div class="col-12">
                                <span>مشتری: </span>
                                <span>{{item.receiveOutSourceName}}</span>
                                <br>
                                <span>شماره سند: </span>
                                <span>{{item.voucherNumber}}</span>
                                <br>
                                <span>تعداد محصولات: </span>
                                <span>{{item.productCount}}</span>
                                <br>
                                <span>تاریخ سند: </span>
                                <span>{{item.voucherDate}}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div v-if="vouchers !== undefined && vouchers.length < 1" class="col-lg-12 text-center mt-5 mb-3">
                <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
            </div>
            <div v-if="vouchers.length < dataCount" class="col-lg-12 text-center my-3">
                <button class="btn btn-success" @click="getVouchers">نمایش اسناد بیشتر
                    ({{vouchers.length}}/{{dataCount}})
                </button>
                <div class="col-2 offset-5 my-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">تعداد نمایش</span>
                        </div>
                        <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>



            <a id="printPaper" class="d-none"></a>
        </div>
        <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap">نام محصول</th>
                                    <th class="text-center text-nowrap">قیمت خرید</th>
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">قیمت فروش</th>
                                </tr>
                                </thead>
                                <tbody v-if="voucher !== undefined">
                                <tr v-for="(item,index) in voucher.products">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.productName}}</td>
                                    <td class="text-center">
                                        {{item.price.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{item.unitVal}}
                                    </td>
                                    <td class="text-center">
                                        {{item.salesPrice.toLocaleString()}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-left"><b>جمع</b></td>
                                    <td class="text-center" v-if="voucher.voucher !== undefined">
                                        <b>{{voucher.voucher.price.toLocaleString()}}</b>
                                    </td>
                                    <td class="text-center"><b>{{overallAmount.toLocaleString()}}</b></td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                            <h4 class="text-center mt-5"
                                v-if=" voucher.products !== undefined && voucher.products.length < 1">محصولی ثبت
                                نشده است!</h4>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <input v-if="voucher.voucher !== undefined" class="form-control" type="text"
                                   v-model="voucher.voucher.description" placeholder="توضیحات" disabled>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <div class="text-right w-100">
                            <span>تاریخ سند: </span>
                            <span v-if="voucher.voucher !== undefined">{{voucher.voucher.persianDate}}</span>
                        </div>
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="voucherDataEdit" tabindex="-1" role="dialog" aria-labelledby="voucherTitleEdit"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitleEdit">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!--<div class="modal-body" id="printMe">-->
                    <div class="modal-body">
                        <div class="table-responsive" id="printMe" v-if="voucher !== undefined">
                            <h6 class="text-center">گزارش بایگانی فروش
                                {{voucher.voucher !== undefined ? voucher.voucher.receiveOutSourceName : ''}}
                                تاریخ
                                {{ voucher.voucher !== undefined ? voucher.voucher.persianDate : '' }}
                                سند شماره
                                {{ voucher.voucher !== undefined ? voucher.voucher.voucherNumber : ''}}
                            </h6>
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap">نام محصول</th>
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">قیمت</th>
                                    <th class="text-center text-nowrap">تخفیف</th>
                                    <th class="text-center text-nowrap">مالیات</th>
                                    <th class="text-center text-nowrap">جمع</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in voucher.products">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.productName}}</td>
                                    <td class="text-center  pb-0">
                                        {{item.unitVal}}
                                    </td>
                                    <td class="text-center pb-0">
                                        {{item.salesPrice.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{item.discount.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{item.taxPrice.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{((item.salesPrice-item.discount+item.taxPrice) * item.unitVal).toLocaleString()}}
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <h4 class="text-center mt-5"
                            v-if="voucher.products !== undefined && voucher.products.length < 1">محصولی ثبت نشده
                            است!</h4>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تخفیف فاکتور</span>
                            </div>
                            <span class="form-control text-right">{{voucher.voucher !== undefined  && voucher.voucher.discount !== undefined? voucher.voucher.discount.toLocaleString() : 0}}</span>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">مالیات فاکتور</span>
                            </div>
                            <span class="form-control text-right">{{voucher.voucher !== undefined  && voucher.voucher.taxPrice !== undefined? voucher.voucher.taxPrice.toLocaleString() : 0}}</span>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <span class="form-control text-right"  v-if="voucher.voucher !== undefined">{{voucher.voucher.description}}</span>
                        </div>
                        <div class="text-center w-100 p-3 text-bold">
                            <span>قابل پرداخت : </span>
                            <span v-if="voucher.voucher !== undefined">{{(parseInt(voucher.voucher.price)).toLocaleString()}}</span>
                            <span>باقیمانده : </span>
                            <span v-if="voucher.voucher !== undefined">{{(parseInt(voucher.voucher.price) -  voucher.payments.reduce( (acc, itt) => { return acc += itt.price; }, 0)).toLocaleString()}}</span>
                        </div>
                        <!--<hr class=" w100"/>-->
                        <h5 class="w-100 text-center">لیست پرداختها</h5>
                        <div class="w-100 " v-if="voucher.payments !== undefined">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap text-center">مبلغ</th>
                                    <th class=" text-nowrap text-center">تاریخ</th>
                                    <th class="text-center">توضیحات</th>
                                </tr>
                                </thead>
                                <tbody v-if="voucher !== undefined">
                                <tr v-for="(item,index) in voucher.payments">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.price.toLocaleString()}}</td>
                                    <td class="text-nowrap">{{item.fdate}}</td>
                                    <td class="text-center">
                                        {{item.code}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                class="fa fa-print"></i></button>
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger"  @click="onVoucherRemoveClicked(voucher.voucher)" v-if="voucher.voucher !== undefined &&!salemali_close">حذف</button>
                        <button type="button" class="btn btn-primary" v-if="!salemali_close"  @click="onModalEditClicked">ویرایش کلی</button>
                        <button type="button" class="btn btn-primary" v-if="!salemali_close"  @click="onDateEditClicked(voucher.voucher)">ویرایش شماره و تاریخ</button>
                        <button type="button" class="btn btn-success" @click="onPaymentClicked(voucher)"
                                v-if="voucher.voucher !== undefined && (parseInt(voucher.voucher.price) -  voucher.payments.reduce( (acc, itt) => { return acc += itt.price; }, 0)) > 0">
                            پرداخت
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="voucherEdit" tabindex="-1" role="dialog" aria-labelledby="voucherEditTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherEditTitle">ویرایش تاریخ و شماره فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-4 input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شماره فاکتور</span>
                                </div>
                                <input class="form-control" type="number" v-if="voucher.voucher!== undefined" v-model="voucher.voucher.voucherNumber"
                                       placeholder="شماره فاکتور">
                            </div>
                            <div class="col-lg-6 input-group mt-2">
                                <div class="input-group-prepend" @click="toggleEditDatePicker">
                                    <div class="input-group-text"><span>تاریخ فاکتور</span></div>
                                </div>
                                <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onEditDatePicked"
                                             ref="datePickerStart" style="flex: 1">
                                    <slot>
                                        <input v-model="editDatePersian" class="form-control date-input" readonly="true"
                                               @click="toggleEditDatePicker">
                                        <button class="close reset-date" @click="resetStartDate">×</button>
                                    </slot>
                                </date-picker>
                            </div>
                            <div class="col-lg-12 input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" type="text" v-if="voucher.voucher!== undefined" v-model="voucher.voucher.description"
                                       placeholder="توضیحات فاکتور">
                            </div>
                            <div class="col-lg-12 text-center m-2">
                                <button type="button" class="btn btn-success mr-1" @click="saveVoucher">ذخیره</button>
                                <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect"
    import VueHtmlToPaper from 'vue-html-to-paper';
    import html2canvas from 'html2canvas';


    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'sell-archive',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                vouchers: [],
                voucher: {},
                overallAmount: 0,
                queryParams: {
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1
                },
                dataCount: 0,

                listView: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                editDatePersian: "",
                startDatePersian: "",
                endDatePersian: "",
                providers: [],
                selectedProvider: 0,
                salemali_close:false,
            }
        },
        mounted() {
            const cc = localStorage.getItem("salemali_close");
            if (cc !== undefined && cc != null && cc === "true") {
                // Utils.handleErrorWithNotification("سال مالی بسته شده است و امکان ثبت جدید وجود ندارد", this.$noty);
                // this.$router.push({name: 'home'});
                this.salemali_close =true;
            }
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                this.vouchers = response.data.data;
                this.dataCount = response.data.count;
                $("#loading").hide();
                for (let item of this.vouchers) {
                    item.voucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                }
            }).catch(error => {
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            this.getProviders();
        },
        methods: {
            changePageSize(e) {
                this.getVouchers(-1);
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            // onPrintClicked() {
            //     html2canvas(document.getElementById("printMe")).then(function (canvas) {
            //         // document.body.appendChild(canvas);
            //         const dataURL = canvas.toDataURL();
            //         const a = document.getElementById("printPaper"); //Create <a>
            //
            //
            //         a.width = dataURL.naturalWidth;
            //         a.height= dataURL.naturalHeight*3;
            //
            //         // a.getContext('2d');
            //         // a.imageSmoothingEnabled = false;
            //
            //
            //
            //         a.href = "data:image/" + dataURL; //Image Base64 Goes here
            //         let d = new Date();
            //         let dt = d.getMilliseconds();
            //         let r = Math.floor(Math.random() * 1000);
            //         a.download = "Image" + r + dt + ".jpg";
            //         a.click();
            //         // a.hidden;
            //     });
            // },

            getVouchers(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.vouchers = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                this.queryParams.type = 1;
                $("#loading").show();
                new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                    let newItems = response.data.data;
                    this.dataCount = response.data.count;
                    for (let item of newItems) {
                        item.voucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                    this.vouchers.push.apply(this.vouchers, newItems);
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(e, index) {
                this.overallAmount = 0;
                let id = this.vouchers[index].id;
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;
                    }
                    if (this.voucher.payments != undefined && this.voucher.payments != null) {
                        for (let i of this.voucher.payments) {
                            i.fdate = Moment(i.check.checkDate, 'YYYY-MM-DD HH:mm').format('jYYYY/jMM/jDD-HH:mm');
                        }
                    }
                    let todayDate = new Date().toJSON().slice(0, 10);
                    this.voucher.voucher.voucherDate = this.voucher.voucher.voucherDate.slice(0, 10);
                    this.voucher.pdate = this.voucher.voucher.persianDate;
                    this.voucher.vNum = this.voucher.voucher.voucherNumber;
                    this.voucher.name = this.voucher.voucher.receiveOutSourceName;


                        $("#voucherDataEdit").modal("show");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                })
            },
            getProviders() {
                this.queryParams = {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    types: 3
                };
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.providers = response.data.data;
                    let allPro = {
                        id: 0,
                        outSourceName: "همه مشتری ها"
                    };
                    this.providers.push(allPro);
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
                this.queryParams = {
                    pageSize: 12,
                    pageIndex: 0,
                    name: "",
                    types: 2
                };

            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEditDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onEditDatePicked(val) {
                this.voucher.voucher.voucherDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.editDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onStartDatePicked(val) {
                this.fromDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.toDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                this.getReport();
            },
            resetStartDate() {
                this.fromDate = '';
                this.startDatePersian = '';
            },
            resetEndDate() {
                this.toDate = '';
                this.endDatePersian = '';
            },
            getReport() {
                this.queryParams = {
                    reciveId: this.selectedProvider,
                    from: this.fromDate,
                    to: this.toDate,
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1

                };
                new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                    this.vouchers = response.data.data;
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                    for (let item of this.vouchers) {
                        item.voucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            onChange(val) {
                this.selectedProvider = val.id;
                this.queryParams = {
                    reciveId: this.selectedProvider,
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1
                };
                new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                    this.vouchers = response.data.data;
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                    for (let item of this.vouchers) {
                        item.voucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });


            },

            onModalEditClicked() {
                if (localStorage.getItem("companyPostName") === 'مدیر') {
                    $("#voucherDataEdit").modal("hide");
                    // if (this.voucher.type === "buy") {
                    // console.log(this.voucher)
                    let newVoucher = this.voucher.voucher;
                    newVoucher.voucherProductDto = this.voucher.products;
                    newVoucher.overallAmount = 0;
                    for (let pro of newVoucher.voucherProductDto) {
                        newVoucher.overallAmount += pro.unitVal;
                        newVoucher.sellPrice = pro.salesPrice;
                    }
                    newVoucher.overallPrice = newVoucher.price;

                    let obj = {
                        name: 'sell',
                        params: {
                            id: this.voucher.voucher.receiveOutSourceId,
                            outSourceName: this.voucher.voucher.receiveOutSourceName,
                            voucher: newVoucher,
                            fromEdit: true
                        }
                    };
                    this.$router.push(obj);
                    // } else {
                    //     let obj = {
                    //         name: 'sell',
                    //         params: {
                    //             voucher: this.voucher
                    //         }
                    //     };
                    //     this.$router.push(obj);
                    // }
                } else {
                    this.$noty.success("با عرض پوزش، شما مجاز به ویرایش رسید نیستید.");
                }
            },
            onVoucherRemoveClicked(item) {
                if (confirm("در صورت تایید اطلاعات دریافت و کالاهای آن حذف میشوند. آیا حذف فاکتور را تایید میکنید؟")) {
                    new BaseService('Voucher', `/DeleteVoucher/${item.id}`).create().then(response => {
                        this.$noty.success('سند با موفقیت حذف شد');
                        this.getVouchers(-1);
                        $("#voucherDataEdit").modal("hide");
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }
            },
            onDateEditClicked(item) {
                this.voucher.voucher =item;
                this.editDatePersian =  Moment(this.voucher.voucher.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                $("#voucherEdit").modal("show");
            },
            saveVoucher() {
                new BaseService('Voucher', '/editVoucher').update(this.voucher.voucher).then(response => {
                    this.$noty.success('سند با موفقیت ویرایش شد');
                    $("#voucherEdit").modal("hide");
                    $("#voucherDataEdit").modal("hide");
                    this.getVouchers(-1);
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                });
            },
            onPaymentClicked(item) {
                let remain = parseInt(item.voucher.price) - item.payments.reduce((acc, itt) => {
                    return acc += itt.price;
                }, 0);
                item.voucher.overallPrice = remain;
                item.voucher.overallAmount = 0;
                for (let p of item.products) {
                    item.voucher.overallAmount += p.unitVal;
                }
                if (!isNaN(item.voucher.overallPrice) && !isNaN(item.voucher.overallAmount)) {
                    item.voucher.voucherProductDto = item.products;
                    $("#voucherDataEdit").modal("hide");
                    let obj = {
                        name: 'payment',
                        path: '/payment',
                        params: {
                            voucher: item.voucher,
                            type: "sell"
                        }
                    };


                    this.$router.push(obj);
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }
            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                if ($("#voucherDataEdit").hasClass("show")) {
                    $("#voucherDataEdit").modal("hide");
                    next(false);
                } else {
                    next();
                }
            }


        },
    }
</script>